import {
  Bell,
  BellPlus,
  CalendarClock,
  Clock,
  Gavel,
  HandCoins,
  LayoutGrid,
  ShoppingBag,
  ShoppingCart,
  Store,
  Tag,
  type LucideIcon,
  type LucideProps,
} from "lucide-react";

export const CommerceIcons = {
  buyNow: ShoppingBag,
  addToCart: ShoppingCart,
  offer: HandCoins,
  bid: Gavel,
  preOrder: Clock,
  scheduledDrop: CalendarClock,
  reminder: Bell,
  reminderSubscribe: BellPlus,
  browse: LayoutGrid,
  browseAlt: Store,
  price: Tag,
} as const satisfies Record<string, LucideIcon>;

export type CommerceIconKey = keyof typeof CommerceIcons;

export function CommerceIcon({
  name,
  className,
  ...props
}: { name: CommerceIconKey; className?: string } & LucideProps) {
  const Icon = CommerceIcons[name];
  return <Icon className={className} {...props} />;
}
